export const MAP_VIEW_CLASSIC = 'classic';
export const MAP_VIEW_3D = '3d';
export const MAP_VIEW_STORAGE_PREFIX = 'pfandpirat.mapViewPreference';

export function isMapViewPreference(value) {
  return value === MAP_VIEW_CLASSIC || value === MAP_VIEW_3D;
}

export function normalizeMapViewPreference(value) {
  return isMapViewPreference(value) ? value : MAP_VIEW_CLASSIC;
}

export function mapViewStorageKey(userId) {
  return `${MAP_VIEW_STORAGE_PREFIX}.${String(userId || 'guest')}`;
}

export function readMapViewQaOverride(search = '') {
  return new URLSearchParams(String(search || '')).get('pfp_3d_map') === '1' ? MAP_VIEW_3D : null;
}

export function resolveInitialMapView({ available, queryPreference, serverPreference, localPreference }) {
  if (!available) return MAP_VIEW_CLASSIC;
  if (queryPreference === MAP_VIEW_3D) return MAP_VIEW_3D;
  if (serverPreference !== undefined && serverPreference !== null && serverPreference !== '') {
    return normalizeMapViewPreference(serverPreference);
  }
  return normalizeMapViewPreference(localPreference);
}

export function urlWithoutMapViewOverride(href) {
  const url = new URL(href);
  url.searchParams.delete('pfp_3d_map');
  return url.toString();
}

export function supportsWebGl(documentObject = globalThis.document) {
  try {
    const canvas = documentObject?.createElement?.('canvas');
    return Boolean(canvas?.getContext?.('webgl2') || canvas?.getContext?.('webgl'));
  } catch {
    return false;
  }
}
